var map = {
	"./backgrounds/01-001-lorwyn-boggart.webp": 388,
	"./backgrounds/3H8hMTEhhnho_HeroHeader_1600x1080.webp": 7993,
	"./backgrounds/457518_cn_flat-rev_4-full-copy.webp": 2129,
	"./backgrounds/556708673_18485695318076698_5020924570195486162_n.webp": 7532,
	"./backgrounds/612257454_18503097013076698_4426842715358683845_n.webp": 1569,
	"./backgrounds/A4lFypkgHf.webp": 6468,
	"./backgrounds/E9lxLBJVGj.webp": 9127,
	"./backgrounds/GZDFVt5kBd.webp": 4957,
	"./backgrounds/IR5vRSD44J.webp": 4715,
	"./backgrounds/L81Xuh17bg.webp": 8881,
	"./backgrounds/U3Vf0uuPoM.webp": 2304,
	"./backgrounds/Underrated-Cards-Lorwyn-Eclipsed-MTG-Featured-Image.webp": 9318,
	"./backgrounds/ashlings-command-card-artwork-mtg-lorwyn-eclipsed.webp": 6124,
	"./backgrounds/ecl-a-few-more-pieces-of-lorwyn-eclipsed-artwork-v0-06cw76xpfzsf1.webp": 1897,
	"./backgrounds/ecl-a-few-more-pieces-of-lorwyn-eclipsed-artwork-v0-nwimgbxpfzsf1.webp": 3554,
	"./backgrounds/edge-of-eternities-artwork-part-2-of-recent-art-roundup-v0-vwinvruqcq8f1.webp": 3085,
	"./backgrounds/jvG0lIxaeQ.webp": 2479,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-0a4urlmwz82g1.webp": 3540,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-0iyjwkmwz82g1.webp": 4812,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-27l3skmwz82g1.webp": 126,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-841qdpmwz82g1.webp": 9496,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-csd5zlmwz82g1.webp": 2887,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-fvv6qkmwz82g1.webp": 7358,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-k4o1clmwz82g1.webp": 3458,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-n75melmwz82g1.webp": 3690,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-ovb2skmwz82g1.webp": 9507,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-wevaylmwz82g1.webp": 4910,
	"./backgrounds/lorwyn-eclipsed-artwork-from-a-lorwyn-first-light-review-v0-ytc9eomwz82g1.webp": 7637,
	"./backgrounds/rQ5sFit7uf.webp": 7928,
	"./backgrounds/rimeclin-recluse-card-artwork-mtg-lorwyn-eclipsed.webp": 5086,
	"./backgrounds/ssRHqUkpqN.webp": 8692,
	"./backgrounds/vinebred-brawler-card-artwork-mtg-lorwyn-eclipsed.webp": 8506,
	"./foil_indicator.png": 7075,
	"./foil_indicator.svg": 6980,
	"./logo.svg": 5429,
	"./user.svg": 8830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;